var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('el-dropdown',[_c('i',{staticClass:"el-icon-setting",staticStyle:{"margin-right":"15px"}}),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',[_c('div',{on:{"click":function($event){return _vm.logout()}}},[_vm._v("退出")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }